import React from 'react';
import { ArtificialProposalResponse } from 'v2/models';
import { FreeUserBeacon } from 'v2/common/FreeUserBeacon/FreeUserBeacon';
import classnames from 'classnames';
import styles from './freeResponseItem.module.scss';
import { Link } from 'react-router-dom';

interface FreeResponseItemProps {
  response: ArtificialProposalResponse;
}

export const FreeResponseItem = ({ response }: FreeResponseItemProps) => {
  const isFakeResponse = response.proposal === null;

  return (
    <div className={classnames(styles.freeResponseContainer)}>
      <FreeUserBeacon />
      <div className={classnames(styles.freeResponseLeft)}>
        <h5>{isFakeResponse && 'Generated'} Response:</h5>
        {isFakeResponse && (
          <p className={classnames(styles.freeResponseDescription)}>
            This is an automatically generated response based on real responses
            from this provider. Please subscribe in order to receive an actual
            response from this provider.
          </p>
        )}
        <p>{response.response}</p>

        <p className={classnames(styles.freeResponseSubscribe)}>
          Interested in talking more with this provider?
          <Link to="/settings/subscription">Subscribe here</Link>
        </p>
      </div>
      <div className={classnames(styles.freeResponseRight)}>
        <h5>{response.data_provider.classification}</h5>
        <p>{response.data_provider.anonymous_description}</p>
      </div>
    </div>
  );
};
